import Axios from "axios";
import {
    data
} from "jquery";
import {
    clearFeedbacksByName,
    clearInputsByName,
    getInputsByName
} from "../helpers/forms";
import handleAjaxError from "../helpers/handleAjaxError";
import {
    toUrl
} from "../helpers/url";

const fields = [
    'company_name',
    'domain',
    'first_name',
    'last_name',
    'email',
    'address',
    'city',
    'state',
    'zip',
    'password',
    'password_confirmation',
    'phone[]',
];

function initSignup() {

    initStripe();
    window.card_validated = false;
    window.card_validation_error = 'Please fill in your credit card details';

    document.getElementById('submitDomainFormButtom').onclick = initSubmitProcess;
}

function initSubmitProcess() {

    document.getElementById('stripe-credit-card-errors').innerText = '';
    document.getElementById('stripe-credit-card').classList.remove('is-invalid');

    loading();

    if (window.testEnabled && window.testPaymentMethodId) {
        // Use test data, skip payment validation
        const data = getFormData();
        data.stripePaymentMethodId = window.testPaymentMethodId;
        submitDomainData(data);
        return;
    }


    if (!window.card_validated) {
        document.getElementById('stripe-credit-card-errors').innerText = window.card_validation_error;
        document.getElementById('stripe-credit-card').classList.add('is-invalid');
        stopLoading();
        return;
    }

    window.stripeClient.createPaymentMethod({
        type: 'card',
        card: window.card,
    }).then(result => {
        if (result.error) {
            console.log(result)
            stopLoading();
            Swal.fire({
                icon: 'error',
                text: 'Oops something went wrong, please try again'
            });
        } else {
            const data = getFormData();
            data.stripePaymentMethodId = result.paymentMethod.id;
            submitDomainData(data);
        }
    }).catch(result => {
        stopLoading();
        console.log(result);
        Swal.fire({
            icon: 'error',
            text: result.error ? result.error : 'Oops something went wrong, please try again'
        });
    })
}

function submitDomainData(data) {
    clearFeedbacksByName(document, fields);
    Axios.post(toUrl('/signup'), data)
        .then(response => {
            stopLoading();
            displaySuccessMessage(response.data);
        })
        .catch(e => {
            stopLoading();
            handleAjaxError(e, document)
        })
}


function getFormData() {
    const data = getInputsByName(document, fields);

    // Put phone in array for easy validation

    data.phone = [data['phone[]']];

    return data;
}

function displaySuccessMessage(response) {
    Swal.fire({
        icon: 'success',
        title: 'Welcome',
        text: 'Please give us a minute to set up your space',
        confirmButtonText: `
			<div class="loading" id="domainLoadingButton" style="display: block; position: relative; background-color: transparent; min-width: 100px; min-height: 24px" aria-hidden="true">
				<div class="lds-ring" style="width: 28px; height: 28px; position: absolute; margin: 0; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%)">
					<div style="width: 28px; height: 28px; margin: 0; left: 0px; top: 0px"></div>
					<div style="width: 28px; height: 28px; margin: 0; left: 0px; top: 0px"></div>
					<div style="width: 28px; height: 28px; margin: 0; left: 0px; top: 0px"></div>
					<div style="width: 28px; height: 28px; margin: 0; left: 0px; top: 0px"></div>
				</div>
			</div>
		`,
        allowOutsideClick: false
    }).then((result) => {
        const url = response.url
        document.location.href = url;
    })
    document.getElementById('domainLoadingButton').parentElement.disabled = true;
    initSpace();
    waitForSpaceReady();
}

function waitForSpaceReady() {
    const domain = document.getElementById('domain').value;
    $.ajax({
        url: window.checkDomainUrl + `?domain=${domain}`,
        type: 'get',
        dataType: 'json',
        enctype: 'multipart/form-data',
        contentType: false,
        processData: false,
        error: function (response) {
            if (response.responseJSON.errors != undefined) {
                $.each(response.responseJSON.errors, function (k, v) {
                    if (k.indexOf('.') !== -1) {
                        var ke = k.split('.');
                        form.find('.' + ke[0]).each(function (ph_i, ph_v) {
                            if (ke[1] == ph_i) {
                                $(this).addClass('is-invalid').parents('.input-group')
                                    .find('.invalid-feedback').text(v.join('. '));
                            }
                        });
                    } else {
                        form.find('#' + k).addClass('is-invalid').parents('.form-group')
                            .find('.invalid-feedback').text(v.join('. '));
                    }
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    text: response.responseJSON.message != undefined ? response.responseJSON.message : 'Oops something went wrong, please try again'
                });
            }
        },
        success: function (response) {
            if (response.message != 'ready') {
                setTimeout(waitForSpaceReady, 0);
            } else {
                document.getElementById('domainLoadingButton').parentElement.disabled = false;
                document.getElementById('domainLoadingButton').innerHTML = 'Continue';
                document.getElementById('domainLoadingButton').parentElement.parentElement.parentElement.children[1].children[0].innerHTML = 'We are ready'

                setTimeout(() => {
                    document.getElementById('domainLoadingButton').parentElement.click();
                }, 5000);
            }
        },
    });
}

function initSpace() {
    const domain = document.getElementById('domain').value;
    $.ajax({
        url: window.initDomainUrl + `?domain=${domain}`,
        type: 'get',
        dataType: 'json',

        enctype: 'multipart/form-data',
        contentType: false,
        processData: false,
        success: function (response) {
            console.log('domain ready');
        },
    });
}

function initStripe() {
    const stripeClient = Stripe(window.stripe_public_key);
    window.stripeClient = stripeClient;

    const elements = stripeClient.elements();

    let card = elements.create('card', {
        hidePostalCode: true,
        style: {
            base: {
                fontSize: '16px',
            }
        }
    });
    card.mount('#stripe-credit-card');

    card.on('change', handleCardChange);

    window.card = card;
}

function handleCardChange(event) {
    window.card_validated = event.complete;
    if (event.complete) {
        window.card_validation_error = null;
    } else {
        if (event.error) {
            window.card_validation_error = event.error.message;
        } else {
            window.card_validation_error = 'Please fill in your credit card details';
        }
    }
}

export {
    initSignup
};
